/**
 * AudienceSwitch — "My silo for: YouTubers · Businesses · Anyone".
 *
 * Oct 2026 (HOMEPAGE_AUDIENCE_PATHS.md §13). This replaced the three large cards
 * that used to stand down the right of the hero — Randy: *"I actually don't like
 * the huge 3 cards… remove them and change it to the way I have in the picture."*
 * His picture is one quiet line centred inside the top of the hero panel, with no
 * descriptions: *"we don't need the descriptors. if user hovers over, perhaps
 * then."* So the sentence for each telling arrives as a tooltip on hover.
 *
 * It is a switch, not navigation: no address change, no persistence, Anyone is
 * where the page starts.
 */
import { AUDIENCES, AUDIENCE_KEYS } from "@/lib/audiences";

export default function AudienceSwitch({ value, onChange, dark = true }) {
  return (
    <div
      className="mb-7 text-sm flex flex-col items-center gap-1 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-1.5 sm:gap-y-1"
      data-testid="landing-audience-switch"
    >
      <span className={dark ? "text-[#F5F1E8]/85" : "text-[#1C1B1A]/70"}>My silo for:</span>
      {/* Oct 23, 2026 (Randy) — on a phone the row used to break after
          "Businesses" and leave Anyone orphaned on its own line. The label sits
          above and the three stay on one line until there is room for all four. */}
      <span className="flex items-center justify-center gap-x-1.5 whitespace-nowrap">
      {AUDIENCE_KEYS.map((key) => {
        const a = AUDIENCES[key];
        const on = value === key;
        return (
          <span key={key} className="relative group">
            <button
              type="button"
              onClick={() => onChange(key)}
              data-testid={`landing-audience-${key}`}
              aria-pressed={on}
              className={`px-2 py-0.5 rounded-full transition-all duration-300 ${
                on
                  ? "text-[#FFC24A] bg-[#FFC24A]/12 ring-1 ring-[#FFC24A]/35"
                  : dark
                    ? "text-[#FFC24A]/75 hover:text-[#FFC24A] hover:bg-[#FFC24A]/10"
                    : "text-[#8A6A2F] hover:text-[#1C1B1A] hover:bg-[#1C1B1A]/5"
              }`}
            >
              {a.switchLabel}
            </button>
            {/* The description Randy didn't want on screen, kept for the hover. */}
            <span
              role="tooltip"
              className="pointer-events-none hidden lg:block absolute left-1/2 top-full z-20 mt-2 w-56 -translate-x-1/2 rounded-lg border border-[#F5F1E8]/15 bg-[#0A0D12]/95 px-3 py-2 text-[11.5px] leading-snug text-[#E7E2D6]/90 opacity-0 shadow-[0_14px_40px_-16px_rgba(0,0,0,0.9)] transition-opacity duration-200 group-hover:opacity-100"
              data-testid={`landing-audience-${key}-hint`}
            >
              {a.cardLine}
            </span>
          </span>
        );
      })}
      </span>
    </div>
  );
}
